// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.logo {
	width: 211px;
	height: auto;
  margin-top: 7px;
}
.navbar {
 
  background: transparent;
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  position: sticky;
  top: 0;
  z-index: 1;
  
  
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  
}

.container {
  z-index: 1;
  width: 100%;
  /* max-width: 1599px; */
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;
}


.navbar-icon {
  margin-right: 0.5rem;
}

.nav-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  list-style: none;
  text-align: center;
  justify-content: flex-end;
  height: 29px;
  margin-top: 23px;
}

.nav-item {
  height: 100%;
  
}



.nav-links {
  font-family: 'Rubik', sans-serif;
  color: rgb(0, 0, 0);
  display: block;
  align-items: center;
  text-decoration: none;
  padding: 0.6rem 1.3rem;
  height: 100%;
  line-height: 5px;
  margin-top: 0px;
}

#dark .nav-links {color:rgb(255, 255, 255); text-shadow: 1px 1px #000000b9;}

.nav-links sup {
	font-size: 9px;
 
}

#dark .activated {
 
	color: rgb(0, 0, 0);
  }
.activated {
  background-color: rgba(0, 0, 0, 0.89);
	color: rgb(0, 204, 255);
	border-radius: 50px;
  }

.fa-bars {
  color: #fff;
}

.menu-icon {
  display: none;
}

@media screen and (max-width: 960px) {
  .NavbarItems {
    position: relative;
  }
  .activated {
    background: none;
    border-radius: 0;
    width: 70vw;
    
    color: rgb(0, 204, 255)!important;
    
    border-radius: 0px;
    }
  .nav-menu {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: absolute;
    justify-content: center;
    top: 43px;
    left: -100%;
    opacity: 1;
    transition: all 0.5s ease;
  }

  .nav-menu.active {
    background: #000000f2;
    height: 100vh;
    left: 0;
    opacity: 1;
    
    z-index: 1;
  }

  .nav-links {
    color: rgb(255, 255, 255);
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
  }

  .nav-links:hover {
    color: #09bef0;
    transform: scale(1.2);
    transition: all 0.3s ease;
  }

  .nav-item:hover {
    border: none;
  }

  .nav-item {
    width: 100%;
    height: 100px;
  }

  .navbar-logo {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(25%, 50%);
  }

  .menu-icon {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    background: #000;
    border-radius: 5px;
    padding: 3px;
    line-height: 11px;
  }
  .logo{
    width: 130px;
    height: auto;
    margin-top: -1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;CACC,YAAY;CACZ,YAAY;EACX,eAAe;AACjB;AACA;;EAEE,uBAAuB;EACvB,kCAA0B;UAA1B,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;;;AAGZ;;AAEA;EACE,aAAa;EACb,8BAA8B;;AAEhC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;;AAEd;;;;AAIA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kBAAkB,wBAAwB,EAAE,8BAA8B,CAAC;;AAE3E;CACC,cAAc;;AAEf;;AAEA;;CAEC,mBAAmB;EAClB;AACF;EACE,qCAAqC;CACtC,uBAAuB;CACvB,mBAAmB;EAClB;;AAEF;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;;IAEX,iCAAiC;;IAEjC,kBAAkB;IAClB;EACF;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,aAAa;IACb,OAAO;IACP,UAAU;;IAEV,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.logo {\n\twidth: 211px;\n\theight: auto;\n  margin-top: 7px;\n}\n.navbar {\n \n  background: transparent;\n  backdrop-filter: blur(8px);\n  height: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.1rem;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  \n  \n}\n\n.navbar-container {\n  display: flex;\n  justify-content: space-between;\n  \n}\n\n.container {\n  z-index: 1;\n  width: 100%;\n  /* max-width: 1599px; */\n  margin-right: auto;\n  margin-left: auto;\n  padding-right: 50px;\n  padding-left: 50px;\n}\n\n\n.navbar-icon {\n  margin-right: 0.5rem;\n}\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  list-style: none;\n  text-align: center;\n  justify-content: flex-end;\n  height: 29px;\n  margin-top: 23px;\n}\n\n.nav-item {\n  height: 100%;\n  \n}\n\n\n\n.nav-links {\n  font-family: 'Rubik', sans-serif;\n  color: rgb(0, 0, 0);\n  display: block;\n  align-items: center;\n  text-decoration: none;\n  padding: 0.6rem 1.3rem;\n  height: 100%;\n  line-height: 5px;\n  margin-top: 0px;\n}\n\n#dark .nav-links {color:rgb(255, 255, 255); text-shadow: 1px 1px #000000b9;}\n\n.nav-links sup {\n\tfont-size: 9px;\n \n}\n\n#dark .activated {\n \n\tcolor: rgb(0, 0, 0);\n  }\n.activated {\n  background-color: rgba(0, 0, 0, 0.89);\n\tcolor: rgb(0, 204, 255);\n\tborder-radius: 50px;\n  }\n\n.fa-bars {\n  color: #fff;\n}\n\n.menu-icon {\n  display: none;\n}\n\n@media screen and (max-width: 960px) {\n  .NavbarItems {\n    position: relative;\n  }\n  .activated {\n    background: none;\n    border-radius: 0;\n    width: 70vw;\n    \n    color: rgb(0, 204, 255)!important;\n    \n    border-radius: 0px;\n    }\n  .nav-menu {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: absolute;\n    justify-content: center;\n    top: 43px;\n    left: -100%;\n    opacity: 1;\n    transition: all 0.5s ease;\n  }\n\n  .nav-menu.active {\n    background: #000000f2;\n    height: 100vh;\n    left: 0;\n    opacity: 1;\n    \n    z-index: 1;\n  }\n\n  .nav-links {\n    color: rgb(255, 255, 255);\n    text-align: center;\n    padding: 2rem;\n    width: 100%;\n    display: table;\n  }\n\n  .nav-links:hover {\n    color: #09bef0;\n    transform: scale(1.2);\n    transition: all 0.3s ease;\n  }\n\n  .nav-item:hover {\n    border: none;\n  }\n\n  .nav-item {\n    width: 100%;\n    height: 100px;\n  }\n\n  .navbar-logo {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate(25%, 50%);\n  }\n\n  .menu-icon {\n    display: block;\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translate(-100%, 60%);\n    font-size: 1.8rem;\n    cursor: pointer;\n    background: #000;\n    border-radius: 5px;\n    padding: 3px;\n    line-height: 11px;\n  }\n  .logo{\n    width: 130px;\n    height: auto;\n    margin-top: -1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
